/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Orbit = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "12", cy: "12", r: "3" }],
    ["circle", { cx: "19", cy: "5", r: "2" }],
    ["circle", { cx: "5", cy: "19", r: "2" }],
    ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416" }],
    ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416" }]
  ]
];

export { Orbit as default };
//# sourceMappingURL=orbit.js.map
